import { Children, isValidElement, ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Icon as BaseIcon } from "@sellar-io/components";
import {
  MenuDrawerListElementIconProps,
  MenuDrawerListElementLabelProps,
  MenuDrawerListElementLabel,
} from "./MenuDrawerListElement";
import { NavigationListElementBase } from "./MenuDrawerListElementBase";
import { NavigationListElementBaseProps } from "./MenuDrawerListElementBase.shared";

const Icon = ({ icon }: MenuDrawerListElementIconProps) => {
  // Match the parent menu icon slot so submenu labels start from a consistent x-position.
  return (
    <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center">
      <BaseIcon icon={icon} size={1} />
    </div>
  );
};

const Label = (props: MenuDrawerListElementLabelProps) => {
  return <MenuDrawerListElementLabel {...props} className={"text-base"} />;
};

const getLabelContent = (children: ReactNode) => {
  const label = Children.toArray(children).find(
    (
      child,
    ): child is ReactElement<MenuDrawerListElementLabelProps, typeof Label> =>
      isValidElement(child) && child.type === Label,
  );

  return label?.props.children;
};

const SubMenuDrawerListElementRoot = (
  props: NavigationListElementBaseProps,
) => {
  return (
    <NavigationListElementBase
      {...props}
      tooltipContent={getLabelContent(props.children)}
      className={twMerge(
        "flex cursor-pointer items-center gap-1 space-x-2 rounded-lg p-1.5 hover:bg-gray-100",
        "mx-0",
        props.className,
      )}
    />
  );
};

export {
  SubMenuDrawerListElementRoot as SubMenuDrawerListElement,
  Icon as SubMenuDrawerListElementIcon,
  Label as SubMenuDrawerListElementLabel,
};
